// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = '51d3e9771e654f3ba9bb88945d02bcca4c4b4bc5';
export const BUILD_NUMBER = '197';
export const BUILD_TIMESTAMP = '2026-07-17T04:23:58.820Z';
